



export const Perguntas = () => {

    return (
        <div>
            
            <h1>Perguntas</h1>
            
            
        </div>



    )
}